import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'payment-history.table-column.subtotal-fee',
    country: ['GB']
  },
  {
    feature: 'payment-history.table-template',
    country: [
      'MX',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'statusDesc',
          'referenceNumber',
          'date',
          'transactionDesc',
          'userAccount',
          'amount'
        ],
        inactive: [],
        hidden: []
      }
    }
  },
  {
    feature: 'payment-history.table-template-co',
    country: ['CO'],
    options: {
      columns: {
        active: [
          'statusDesc',
          'referenceNumber',
          'ticketId',
          'date',
          'transactionDesc',
          'userAccount',
          'amount',
        ],
        inactive: [],
        hidden: []
      }
    }
  },
  {
    feature: 'payment-history.table-template-us',
    country: ['US'],
    options: {
      columns: {
        active: [
          'statusDesc',
          'date',
          'referenceNumber',
          'location',
          'transactionDesc',
          'userAccount',
          'totalAmount',

        ],
        inactive: [],
        hidden: []
      }
    }
  },
  {
    feature: 'payment-history-detail.total-paid.co',
    country: ['CO']
  },
  {
    feature: 'payment-history-detail.total-paid.us',
    country: ['US']
  }
] as IAppConfiguration[];
